import './CommentSection.scss'
import Skeleton from '../Skeleton/Skeleton';

const CommentSkeleton = () => {

    return (
        <div className="comment d-flex f-row aic ">
            <Skeleton classNames={'avatar'} width={"32px"} height={"32px"} />
            <div className="content d-flex f-column jcc">
                <Skeleton className="fs-xxs fg-crea fw-medium-bold pt-4" height={"12px"} width='280px' />

                <Skeleton className={"text mt-8 pt-4"} height='12px' borderRadius='12px' width='280px'/>

            </div>
        </div>
    )
}

export default CommentSkeleton